class Filter {
    constructor(type, manager) {
        this._init(type, manager)
    }
    _init(type, manager) {
        this.type = type
        this.manager = manager
        this.el = document.querySelector('[data-filter="' + this.type + '"]')
        if(this.el) {
            this.elSelection = this.el.querySelectorAll('[data-filter-id]')
            this.elSelection.forEach((el) => {
                el.action = new FilterAction(el, this.type, this.manager)
            })
            this.elAmount = this.el.querySelector('[data-filter-amount]')
            // window.addEventListener('popstate', () => this.updateSelection() )
            this.updateSelection()
        }
    }
    updateSelection() {
        if(!this.el) {
            return
        }
        const mParams = this.manager.params
        const typeParams = mParams.getAll(this.type)
        let amount = 0
        this.elSelection.forEach((el) => {
            if(typeParams.includes(el.getAttribute('data-filter-id'))) {
                el.action.setCheck(true)
                amount++
            } else {
                el.action.setCheck(false)
            }
        })
        this.elAmount.innerHTML = amount != 0 ? "(" + amount + ")" : ""
    }
}

class FilterAction {
    constructor(el, type, manager) {
        this._init(el, type, manager)
    }
    _init(el, type, manager) {
        this.el = el
        this.type = type
        this.manager = manager

        this.id = this.el.getAttribute('data-filter-id')
        this.input = this.el.querySelector('[data-filter-input]')
        this.el.addEventListener("change", (e) => {
            // debugger
            // if(!this.manager) {
            //     e.preventDefault()
            //     return
            // }

            this.onClick() 
        })
    }
    onClick() {
        const mParams = this.manager.params
        if(this.isChecked()) {
            const typeParams = mParams.getAll(this.type)
            mParams.delete(this.type)
            const index = typeParams.indexOf(this.id)
            typeParams.splice(index, 1)
            typeParams.forEach((param) =>  mParams.append(this.type, param))
        } else {
            mParams.append(this.type, this.id)
        }

        this.manager.updateParams(mParams)
    }
    isChecked() {
        //since js runs after css the checked tag is changed before the event "click" is run
        return !this.input.checked
    }
    setCheck(b) {
        this.input.checked = b
    }
    // updateURL(params) {
    //     params.delete('page')
    //     params.delete('view')
    //     params.sort()
    //     window.history.replaceState({}, '', `${location.pathname}?${params}`)
    // }
    // dispatchEvent() {
    //     const popStateEvent = new PopStateEvent('popstate', { state: null })
    //     window.dispatchEvent(popStateEvent)
    // }
}
export default Filter